var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "main-content" }, [
    _c("div", { staticClass: "card" }, [
      _c("div", { staticClass: "card-header flex justify-content-between" }, [
        _c("h5", [_vm._v("На руках у старших курьеров")]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "flex" },
          [
            _c(
              "div",
              [
                _c("DateSelect", {
                  ref: "selectedDate",
                  attrs: {
                    onSelect: _vm.showReport,
                    selectedDate: _vm.selectedDate,
                  },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "vue-ladda",
              {
                attrs: {
                  "button-class": "btn btn-success",
                  "data-style": "zoom-in",
                  loading: _vm.loading,
                },
                on: {
                  click: function ($event) {
                    return _vm.showReport()
                  },
                },
              },
              [_vm._v("Показать\n        ")]
            ),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _vm.showDivBalances
        ? _c(
            "div",
            { staticClass: "card-body" },
            [
              _c("DateBalance", {
                attrs: { setDate: _vm.$refs.selectedDate.date },
              }),
              _vm._v(" "),
              false && !_vm.loading && Object.keys(_vm.balance).length
                ? _c("div", [
                    _c("table", { staticClass: "table table-sm table-hover" }, [
                      _vm._m(0),
                      _vm._v(" "),
                      _c(
                        "tbody",
                        [
                          _vm._l(
                            _vm.mixinGetSortedDivisions(),
                            function (division) {
                              return _c("tr", { key: division.id }, [
                                _c("td", [
                                  _c("p", { staticClass: "division_runner" }, [
                                    _vm._v(
                                      "\n                (" +
                                        _vm._s(division.id) +
                                        ") " +
                                        _vm._s(
                                          (division.user &&
                                            division.user.short_name) ||
                                            "Не привязан"
                                        ) +
                                        "\n                (" +
                                        _vm._s(
                                          division.user && division.user.id
                                        ) +
                                        ")\n              "
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "text-muted" },
                                    [
                                      _vm._l(division.stores, function (store) {
                                        return _c(
                                          "span",
                                          {
                                            key: `store_${store.id}`,
                                            staticClass: "d_info",
                                          },
                                          [
                                            _vm._v(
                                              "\n                    " +
                                                _vm._s(
                                                  _vm.$AllStores[
                                                    store.object_id
                                                  ].short_title
                                                ) +
                                                "\n                  "
                                            ),
                                          ]
                                        )
                                      }),
                                      _vm._v(
                                        "\n                /\n                "
                                      ),
                                      _vm._l(
                                        division.cities,
                                        function (city, index) {
                                          return _c(
                                            "span",
                                            { key: `city_${city.id}` },
                                            [
                                              _vm._v(
                                                _vm._s(index > 0 ? ", " : "") +
                                                  _vm._s(
                                                    _vm.$AllCities[
                                                      city.object_id
                                                    ].name
                                                  )
                                              ),
                                            ]
                                          )
                                        }
                                      ),
                                    ],
                                    2
                                  ),
                                ]),
                                _vm._v(" "),
                                _c("td", [
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(
                                        (_vm.balance[division.id] &&
                                          _vm.balance[division.id].balance &&
                                          _vm.balance[division.id]
                                            .balance[33] &&
                                          _vm.balance[
                                            division.id
                                          ].balance[33].orders.toLocaleString(
                                            "ru-RU"
                                          )) ||
                                          0
                                      ) +
                                      "\n            "
                                  ),
                                ]),
                                _vm._v(" "),
                                _c("td", [
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(
                                        (_vm.balance[division.id] &&
                                          _vm.balance[division.id].balance &&
                                          _vm.balance[division.id]
                                            .balance[28] &&
                                          _vm.balance[
                                            division.id
                                          ].balance[28].orders.toLocaleString(
                                            "ru-RU"
                                          )) ||
                                          0
                                      ) +
                                      "\n            "
                                  ),
                                ]),
                                _vm._v(" "),
                                _c("td", [
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(
                                        (_vm.balance[division.id] &&
                                          _vm.balance[division.id].balance &&
                                          _vm.balance[division.id]
                                            .balance[34] &&
                                          _vm.balance[
                                            division.id
                                          ].balance[34].orders.toLocaleString(
                                            "ru-RU"
                                          )) ||
                                          0
                                      ) +
                                      "\n            "
                                  ),
                                ]),
                                _vm._v(" "),
                                _c("td", [
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(
                                        _vm.totalFigures.byDivision[
                                          division.id
                                        ].toLocaleString("ru-RU")
                                      ) +
                                      "\n            "
                                  ),
                                ]),
                              ])
                            }
                          ),
                          _vm._v(" "),
                          _c("tr", { staticClass: "result_tr" }, [
                            _c("td", [_vm._v("ИТОГО")]),
                            _vm._v(" "),
                            _c("td", [
                              _vm._v(
                                _vm._s(
                                  _vm.totalFigures[33].toLocaleString("ru-RU")
                                )
                              ),
                            ]),
                            _vm._v(" "),
                            _c("td", [
                              _vm._v(
                                _vm._s(
                                  _vm.totalFigures[28].toLocaleString("ru-RU")
                                )
                              ),
                            ]),
                            _vm._v(" "),
                            _c("td", [
                              _vm._v(
                                _vm._s(
                                  _vm.totalFigures[34].toLocaleString("ru-RU")
                                )
                              ),
                            ]),
                            _vm._v(" "),
                            _c("td", [
                              _vm._v(
                                _vm._s(
                                  _vm.totalFigures.grand.toLocaleString("ru-RU")
                                )
                              ),
                            ]),
                          ]),
                        ],
                        2
                      ),
                    ]),
                  ])
                : _vm._e(),
            ],
            1
          )
        : _vm._e(),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "card" }, [
      _c("div", { staticClass: "card-header flex justify-content-between" }, [
        _c("h5", { staticClass: "flex-grow-1" }, [
          _vm._v("Провести групповую инкассацию"),
        ]),
        _vm._v(" "),
        _c(
          "button",
          {
            staticClass: "btn btn-default",
            on: {
              click: function ($event) {
                _vm.showGroupIncashment = !_vm.showGroupIncashment
              },
            },
          },
          [
            _vm._v(
              "\n        " +
                _vm._s(_vm.showGroupIncashment ? "свернуть" : "открыть") +
                "\n      "
            ),
          ]
        ),
      ]),
      _vm._v(" "),
      _vm.showGroupIncashment
        ? _c("div", { staticClass: "card-body" }, [_c("MultiIncashment")], 1)
        : _vm._e(),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "card" }, [
      _vm._m(1),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "card-body" },
        [
          _c("div", { staticClass: "row" }, [
            _c("div", { staticClass: "col-md-9" }, [
              _c(
                "div",
                { staticClass: "form-group" },
                [
                  _c("label", { attrs: { for: "" } }, [
                    _vm._v("Старшие курьеры"),
                  ]),
                  _vm._v(" "),
                  _c("multiselect", {
                    attrs: {
                      options: _vm.divisionsForSelect,
                      multiple: true,
                      label: "name",
                      "track-by": "value",
                      placeholder: "Выберите курьера",
                      "select-label": "Выбрать",
                      "deselect-label": "Удалить курьера",
                    },
                    on: { input: _vm.updateSelected },
                    model: {
                      value: _vm.selectedDivisions,
                      callback: function ($$v) {
                        _vm.selectedDivisions = $$v
                      },
                      expression: "selectedDivisions",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              !_vm.selectedDivisionsIds.includes(0)
                ? _c("div", [
                    _c("div", { staticClass: "form-check" }, [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.filter,
                            expression: "filter",
                          },
                        ],
                        staticClass: "form-check-input",
                        attrs: { type: "radio", id: "r_1", value: "all" },
                        domProps: { checked: _vm._q(_vm.filter, "all") },
                        on: {
                          change: function ($event) {
                            _vm.filter = "all"
                          },
                        },
                      }),
                      _vm._v(" "),
                      _c(
                        "label",
                        {
                          staticClass: "form-check-label",
                          attrs: { for: "r_1" },
                        },
                        [_vm._v("все инкассации")]
                      ),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "form-check" }, [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.filter,
                            expression: "filter",
                          },
                        ],
                        staticClass: "form-check-input",
                        attrs: { type: "radio", id: "r_2", value: "income" },
                        domProps: { checked: _vm._q(_vm.filter, "income") },
                        on: {
                          change: function ($event) {
                            _vm.filter = "income"
                          },
                        },
                      }),
                      _vm._v(" "),
                      _c(
                        "label",
                        {
                          staticClass: "form-check-label",
                          attrs: { for: "r_2" },
                        },
                        [_vm._v("только входящие")]
                      ),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "form-check" }, [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.filter,
                            expression: "filter",
                          },
                        ],
                        staticClass: "form-check-input",
                        attrs: { type: "radio", id: "r_3", value: "outcome" },
                        domProps: { checked: _vm._q(_vm.filter, "outcome") },
                        on: {
                          change: function ($event) {
                            _vm.filter = "outcome"
                          },
                        },
                      }),
                      _vm._v(" "),
                      _c(
                        "label",
                        {
                          staticClass: "form-check-label",
                          attrs: { for: "r_3" },
                        },
                        [_vm._v("только исходящие")]
                      ),
                    ]),
                  ])
                : _vm._e(),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "col-md-3" }, [
              _c("div", { staticClass: "form-group" }, [
                _c("label", { attrs: { for: "" } }, [
                  _vm._v("за последние дней"),
                ]),
                _vm._v(" "),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.incomeDays,
                      expression: "incomeDays",
                    },
                  ],
                  staticClass: "form-control",
                  attrs: { type: "number" },
                  domProps: { value: _vm.incomeDays },
                  on: {
                    change: () => _vm.getIncomes(),
                    input: function ($event) {
                      if ($event.target.composing) return
                      _vm.incomeDays = $event.target.value
                    },
                  },
                }),
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "text-right" },
                [
                  _vm.incomes && _vm.incomes.length
                    ? _c(
                        "vue-ladda",
                        {
                          attrs: {
                            "button-class": "btn btn-outline-primary",
                            "data-style": "zoom-in",
                            loading: _vm.loadingIncomes,
                          },
                          on: { click: () => _vm.getIncomes(true) },
                        },
                        [_vm._v("Экспорт в XLS\n            ")]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "vue-ladda",
                    {
                      attrs: {
                        "button-class": "btn btn-success",
                        "data-style": "zoom-in",
                        loading: _vm.loadingIncomes,
                      },
                      on: { click: () => _vm.getIncomes() },
                    },
                    [_vm._v("Загрузить\n            ")]
                  ),
                ],
                1
              ),
            ]),
          ]),
          _vm._v(" "),
          _c("CustomPulseLoader", { attrs: { loading: _vm.loadingIncomes } }),
          _vm._v(" "),
          _c("div", { staticClass: "p-t-10" }, [
            _vm.incomes.length
              ? _c("table", { staticClass: "table table-sm table-hover" }, [
                  _vm._m(2),
                  _vm._v(" "),
                  _c(
                    "tbody",
                    _vm._l(_vm.incomes, function (record) {
                      return _c("tr", { key: record.id }, [
                        _c(
                          "td",
                          [
                            record.incomes?.length
                              ? _vm._l(record.incomes, function (i) {
                                  return _c("p", [
                                    _c("strong", [_vm._v(_vm._s(i.sum))]),
                                    _vm._v(
                                      "\n                  " +
                                        _vm._s(
                                          _vm.$AllCurrencies[i.currency_id]
                                            .currency
                                        ) +
                                        " : " +
                                        _vm._s(
                                          _vm.$AllDivisions[i.division_id]
                                            ?.title
                                        )
                                    ),
                                  ])
                                })
                              : _vm._e(),
                            _vm._v(" "),
                            record.type_id === 3
                              ? [
                                  _c("strong", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$platformConstants.nonCashResources[
                                          record.source_id
                                        ]?.title
                                      )
                                    ),
                                  ]),
                                ]
                              : [
                                  _c("strong", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$AllDivisions[record.division_id] &&
                                          _vm.$AllDivisions[record.division_id]
                                            .title
                                      )
                                    ),
                                  ]),
                                  _vm._v(
                                    "\n                (" +
                                      _vm._s(
                                        _vm.$AllDivisions[record.division_id]
                                          ?.user?.short_name ??
                                          _vm.$AllDivisions[record.division_id]
                                            ?.user?.name ??
                                          record.division_id
                                      ) +
                                      ")\n              "
                                  ),
                                ],
                          ],
                          2
                        ),
                        _vm._v(" "),
                        _c("td", [
                          _c("div", {
                            domProps: {
                              innerHTML: _vm._s(
                                _vm.getCashoutDirections(record)
                              ),
                            },
                          }),
                        ]),
                        _vm._v(" "),
                        _c("td", [
                          _c("strong", [
                            _vm._v(_vm._s(record.sum.toLocaleString("ru-RU"))),
                          ]),
                        ]),
                        _vm._v(" "),
                        _c("td", [
                          _vm._v(
                            "\n              " +
                              _vm._s(
                                (_vm.$AllCurrencies[record.currency_id] &&
                                  _vm.$AllCurrencies[record.currency_id]
                                    .currency) ||
                                  record.currency_id
                              ) +
                              "\n            "
                          ),
                        ]),
                        _vm._v(" "),
                        _c("td", [
                          _vm._v(
                            "\n              " +
                              _vm._s(
                                _vm.printDate(
                                  record.report_date,
                                  "DD.MM.YYYY HH:mm"
                                )
                              )
                          ),
                          _c("br"),
                          _vm._v(
                            "\n              " +
                              _vm._s(
                                _vm.printDate(
                                  record.created_at,
                                  "DD.MM.YYYY HH:mm"
                                )
                              ) +
                              "\n            "
                          ),
                        ]),
                        _vm._v(" "),
                        _c("td", [
                          record.data?.by_trader
                            ? _c("div", [
                                _c("p", [
                                  _c("strong", [
                                    _vm._v(
                                      _vm._s(
                                        record.data.converted_sum ?? record.sum
                                      )
                                    ),
                                  ]),
                                  _vm._v(" * " + _vm._s(record.data.rate)),
                                ]),
                                _vm._v(" "),
                                _c(
                                  "p",
                                  [
                                    record.data.group_transaction
                                      ? _c(
                                          "span",
                                          { staticClass: "badge badge-info" },
                                          [_vm._v("group")]
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    record?.data?.send_address ||
                                    record?.data?.receive_address
                                      ? [
                                          _vm._v(
                                            "\n                    " +
                                              _vm._s(
                                                (
                                                  record?.data?.send_address ??
                                                  ""
                                                ).length > 10
                                                  ? record.data.send_address.substring(
                                                      0,
                                                      8
                                                    ) + "..."
                                                  : record.data.send_address
                                              ) +
                                              " : " +
                                              _vm._s(
                                                (
                                                  record?.data
                                                    ?.receive_address ?? ""
                                                ).length > 10
                                                  ? record.data.receive_address.substring(
                                                      0,
                                                      8
                                                    ) + "..."
                                                  : record.data.receive_address
                                              ) +
                                              "\n                  "
                                          ),
                                        ]
                                      : _vm._e(),
                                    _vm._v(" "),
                                    record.data.aml_risk
                                      ? _c("span", [
                                          _vm._v("("),
                                          _c("strong", [
                                            _vm._v(
                                              _vm._s(record.data.aml_risk) + "%"
                                            ),
                                          ]),
                                          _vm._v(")"),
                                        ])
                                      : _vm._e(),
                                  ],
                                  2
                                ),
                              ])
                            : _vm._e(),
                        ]),
                        _vm._v(" "),
                        _c("td", [_vm._v(_vm._s(record.comment))]),
                        _vm._v(" "),
                        _c("td", [
                          _vm._v(
                            "\n              " +
                              _vm._s(
                                (_vm.$AllDivisions[record.to_division_id] &&
                                  _vm.$AllDivisions[record.to_division_id].user
                                    .name) ||
                                  record.to_division_id ||
                                  "Администрация"
                              ) +
                              "\n            "
                          ),
                        ]),
                      ])
                    }),
                    0
                  ),
                ])
              : _vm._e(),
          ]),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("thead", [
      _c("tr", [
        _c("th", [_vm._v("Курьер")]),
        _vm._v(" "),
        _c("th", [_vm._v("RUB")]),
        _vm._v(" "),
        _c("th", [_vm._v("EUR")]),
        _vm._v(" "),
        _c("th", [_vm._v("USD")]),
        _vm._v(" "),
        _c("th", [_vm._v("Итого в EUR")]),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "card-header" }, [
      _c("h5", [_vm._v("Список инкассаций")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("thead", [
      _c("tr", [
        _c("th", [_vm._v("Источник")]),
        _vm._v(" "),
        _c("th", [_vm._v("Направление")]),
        _vm._v(" "),
        _c("th", [_vm._v("Сумма")]),
        _vm._v(" "),
        _c("th", [_vm._v("Валюта")]),
        _vm._v(" "),
        _c("th", [_vm._v("Отчет/Создание")]),
        _vm._v(" "),
        _c("th", [_vm._v("Транзакция")]),
        _vm._v(" "),
        _c("th", [_vm._v("Комментарий")]),
        _vm._v(" "),
        _c("th", [_vm._v("Получатель")]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }